<template>
  <div class="container page">
	  
    <van-nav-bar :title="this.lottery.name" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
		<!-- <van-icon name="bars" color="#d5b9a4" size="24" @click="drawer = true" /> -->
      </template>
    </van-nav-bar>
	
	
    <div class="record">
        <div class="period">
            <van-image class="cover" :src="this.lottery.ico">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <!-- <span class="period-number">{{this.lottery.now_expect}}</span> -->
            <span class="period-number">{{this.lottery.next_expect}}</span>
            <div class="next-number">
              <!-- <span>{{this.lottery.next_expect}}</span> -->
              <van-count-down :time="time" @finish="check()" />
            </div>

        </div>
        <div class="linear-gradient" style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));"></div>
        <div class="recent">
          <div class="kuaisan-ball left">
            <van-image class="res-img" :src="this.shanzi_1">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <van-image class="res-img" :src="this.shanzi_2">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <van-image class="res-img" :src="this.shanzi_3">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <span class="res-des middle">{{this.sum}}</span>
            <span class="res-des middle">{{this.size}}</span>
            <span class="res-des middle">{{this.double}}</span>
          </div>
          <van-icon name="arrow-down" :class="{ up: active,down:!active }" @click="active ? active = false : active = true" />
        </div>
    </div>
    <div class="history_popup"></div>
    <div class="wrapper">
        <div class="options-bar">
            <div class="game">
              <div class="tips">
                <div class="tip-btn left-btn">
                  <van-icon name="clock-o" class="tip-icon" />
                  <span class="tip-text">剩餘 <van-count-down :time="time" format="mm:ss" /></span>
                </div>
                <div class="tip-btn right-btn" @click="$router.push({path:'/GameRecord'});">
                  <van-icon name="balance-list-o" class="tip-icon" />
                  <span class="tip-text">{{$t("my.task_record")}}</span>
                </div>
              </div>
              <van-popup class="mask" get-container="body" v-model="playgame">
                <div class="play-type-tip">
                  <div class="title">玩法规则</div>
                  <div class="wrapper">
                    <div class="item">
                      <van-icon name="info-o" />
                      <div class="content">
                        <p class="content-title">玩法提示</p>
                        <p class="content-detail">从可选和值形态里面选择号码进行下注</p>
                      </div>
                    </div>
                    <div class="item">
                      <van-icon name="comment-o" />
                      <div class="content">
                        <p class="content-title">中奖说明</p>
                        <p class="content-detail">三个开奖号码总和值11~18 为大;总和值3~ 10为小;</p>
                      </div>
                    </div>
                    <div class="item">
                      <van-icon name="description" />
                      <div class="content">
                        <p class="content-title">投注范例</p>
                        <p class="content-detail">投注方案：小 开奖号码：123,即中小</p>
                      </div>
                    </div>
                  </div>
                </div>
              </van-popup>
              <div class="linear-gradient" style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));"></div>
              <div class="platform-title">
                <span class="diamond-left">◆</span>
                <span class="title-text">選擇平台</span>
                <span class="diamond-right">◆</span>
              </div>
              <div class="sumValueTwoSides">
                <div class="rectangle large" :class="{active:choose[v.type]}" v-for="(v,key) in lottery_peilv_list" :key="key" @click="choosePlay(v.type,v.name);">
                  <div class="wrapper">
                    <div class="content">
					  <p class="name-text large"><img :src="result2img(v.name)" /></p>
					  <p class="odd-text large" >{{v.name}}</p>
                    </div>
                    <div class="check-icon">
                      <van-icon name="success" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="bottom-bar">
          <div class="bar">
            <div class="left">
              <div class="item" @click="shopping ? shopping = false : shopping = true ">
                <van-icon name="cart-o" class="jixuanico" />
                <span class="text">{{$t("reservation.task_list")}}</span>
              </div>
              <div class="line"></div>
            </div>
            <div class="mid">
              <span class="text">{{$t("reservation.available_balance")}}</span>
              <span class="text num">{{ this.userInfo.money }}</span>
              <span class="text">{{$t("reservation.unit")}}</span>
            </div>
            <div class="right" @click="jiesuan()">
              確認提交
            </div>
          </div>
          <div class="wrapper" :class="{active:shopping}">
               <div class="item">
                 <div class="icon-box">
                   <van-icon name="user-o" class="item-icon" />
                 </div>
                 <span class="label">{{$t("reservation.curr_choose")}}：</span>
                 <div class="bet-number">{{ this.shopchoose}}</div>
                 <van-icon name="arrow-down" :class="{ up: !shopping,down:shopping }" @click="shopping ? shopping = false : shopping = true" />
               </div>
              <div class="item">
                <div class="icon-box">
                  <van-icon name="gold-coin-o" class="item-icon" />
                </div>
                <span class="label">{{$t("reservation.per_price")}}：</span>
                <div class="amount-wrapper">
                  <van-field v-model="money" type="digit" :placeholder="$t('reservation.price_place')" />
                </div>
              </div>
              <div class="item">
                <div class="icon-box">
                  <van-icon name="notes-o" class="item-icon" />
                </div>
                <div class="summary">
                  <span>{{$t("reservation.total")}}</span>
                  <span class="number highlight">{{this.formData.length}}</span>
                  <span>{{$t("reservation.note")}}</span>
                  <span class="divider">|</span>
                  <span>{{$t("reservation.total2")}}</span>
                  <span class="number highlight">{{this.formData.length * this.money}}</span>
                  <span>積分</span>
                </div>
              </div>
          </div>
        </div>
      <van-popup v-model="jiesuanpage" get-container="body" >
        <div class="confirm-order-modal">
            <div class="head van-hairline--bottom">
              <p class="text">{{$t("reservation.task_list")}}</p>
            </div>
            <ul class="list">
                <li v-for="(v,key) in formData" :key="key" class="lise-item van-hairline--bottom">
                    <div class="main">
                      <p class="bet-name">{{ v.name }}</p>
                      <p class="detail-text">1{{$t("reservation.note")}}X{{ money }}{{$t("reservation.unit")}}={{ money }}{{$t("reservation.unit")}}</p>
                    </div>
                    <van-icon @click="clearChooes(v.type)" name="close" />
                </li>
            </ul>
            <div class="sub-bar">
              <van-button class="item cancel-btn" type="default" @click="allClear()">{{$t("reservation.clear_order")}}</van-button>
              <van-button class="item sub-btn" type="default" @click="doSub">{{$t("reservation.submit")}}</van-button>
            </div>
        </div>
      </van-popup>
      <van-popup v-model="active" position="top" :style="{ height: '70%' }" >
              <van-pull-refresh pulling-text="刷新成功" 
			loosing-text="重新整理頁面" 
			loading-text="刷新成功" 
			success-text="刷新成功" v-model="isLoading" @refresh="onRefresh">
                  <div class="wrapper">
                    <div class="item item2">
                      <div class="left font-weight">{{$t("reservation.num")}}</div>
                      <div class="right font-weight" >{{$t("reservation.win_num")}}</div>
                    </div>
                    <div class="item item2" v-for="(v,key) in lottery_list" :key="key">
                      <div class="left font-weight">{{v.expect}}</div>
                      <div class="right font-weight" >
                        <div class="kuaisan-ball left">
                          <van-image class="res-img" :src="'img/lottery/shaizi/' + v.opencode[0] + '.png'">
                            <template v-slot:loading>
                              <van-loading type="spinner"/>
                            </template>
                          </van-image>
                          <van-image class="res-img" :src="'img/lottery/shaizi/' + v.opencode[1] + '.png'">
                            <template v-slot:loading>
                              <van-loading type="spinner"/>
                            </template>
                          </van-image>
                          <van-image class="res-img" :src="'img/lottery/shaizi/' + v.opencode[2] + '.png'">
                            <template v-slot:loading>
                              <van-loading type="spinner"/>
                            </template>
                          </van-image>
                          <span class="res-des middle">{{v.opencode[0] + v.opencode[1] + v.opencode[2]}}</span>
                         <span class="res-des middle">{{(v.opencode[0] + v.opencode[1] + v.opencode[2]) >= 11 && (v.opencode[0] + v.opencode[1] + v.opencode[2]) &lt;= 18 ? "FB" : "TK"}}</span>
                          <span class="res-des middle">{{(v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0 ? "YT" : "IG"}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
              </van-pull-refresh>
        </van-popup>
    </div>
	
	<!-- 左侧抽屉组件 -->
	<el-drawer
	  title=""
	  :visible.sync="drawer"
	  direction="ltr"
	  size="300px"
	  custom-class="my-drawer"
	  :before-close="handleClose">
	  <div>
		<div class="menu-item" @click="toLogin('/Home')">{{ $t("foorter.index") }}</div>
		<div class="menu-item" @click="drawer = false">{{ $t("foorter.subscribe") }}</div>
		<div class="menu-item" @click="toLogin('/Choose')">{{ $t('concubine.concubine') }}</div>
		<div class="menu-item" @click="toLogin('/Video')">{{ $t("foorter.video") }}</div>
		<div class="menu-item" @click="toLogin('/Mine')">{{ $t("foorter.my") }}</div>
	  </div>
	</el-drawer>
  </div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
	  drawer: false, // 控制抽屉打开状态
      jiesuanpage:false,
      choose: {
        "大":false,
        "小":false,
        "单":false,
        "双":false,
        "3":false,
        "4":false,
        "5":false,
        "6":false,
        "7":false,
        "8":false,
        "9":false,
        "10":false,
        "11":false,
        "12":false,
        "13":false,
        "14":false,
        "15":false,
        "16":false,
        "17":false,
        "18":false,
      },
      playgame:false,
      shopping:false,
      isLoading: false,
      play:{},
      lottery_peilv_list:{},
      lottery_list:{},
      active: false,
      userInfo:{},
      lottery:{},
      shanzi_1:"",
      shanzi_2:"",
      shanzi_3:"",
      sum:0,
      size:"",
      double:"",
      time:0,
      shopchoose:this.$t("reservation.no_choose"),
      gameitem:"",
      formData:[],
      money:"",
	  t1: require('../images/lottery/t1.png'),
	  t2: require('../images/lottery/t2.png'),
	  t3: require('../images/lottery/t3.png'),
	  t4: require('../images/lottery/t4.png'),
    };
  },
  methods: {
	  result2img(type) {
	  	let t = this.t1
	  	if(type == 'FB') {
	  		t = this.t1
	  	}else if(type == 'TK') {
	  		t = this.t2
	  	}else if(type == 'IG') {
	  		t = this.t3
	  	}else if(type == 'YT') {
	  		t = this.t4
	  	}
	  	return t
	  },
	handleClose(done) {
	  done();
	},
	toLogin(str) {
	  this.$router.push({ path: str});
	},
    back(){
      return window.history.back();
    },
    doSub(){
      if(this.money === "0"){
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if(this.formData.length === 0){
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      }else if(this.money === ""){
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if(this.userInfo.money - (this.money * this.formData.length) < 0 ){
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        }else {
          this.$http({
            method: 'post',
            data:{
               item:this.gameitem,
               money:this.money,
               lid:this.lottery.id,
               mid:this.userInfo.id,
               expect:this.lottery.now_expect
            },
            url: 'game_place_order'
          }).then(res=>{
            if(res.code === 200){
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            }else if(res.code === 401){
              this.$toast(res.msg);
            }
          })
          return true;
        }
      }
    },
    allClear(){
      for(var i = 0;i<this.formData.length;i++){
          this.choose[this.formData[i]['type']] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem ="";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    jiesuan(){
	  // console.log('666', this.userInfo)
	  // 禁止下注
	  if(this.userInfo.is_bet === 0){
		  this.$toast(this.$t("reservation.betting_prohibited"));
		  return false;
	  }
      if(this.formData.length === 0){
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      }else if(this.money === ""){
        this.$toast(this.$t("reservation.price_place"));
        return false;
      }
      else {
        this.jiesuanpage ? this.jiesuanpage = false : this.jiesuanpage = true;
      }

    },
    clearChooes(type){
      for(var i = 0;i<this.formData.length;i++){
        if(type === this.formData[i]['type'] ){
          this.formData.splice(i,1)
          this.choose[type] = false;
        }
      }
      if(this.formData.length >= 1){
        for(var j = 0;j < this.formData.length;j++){
          if(j === 0){
            this.shopchoose = this.formData[j]['name'];
            this.gameitem = this.formData[j]['type'];
          }else {
            this.shopchoose += ","+this.formData[j]['name'];
            this.gameitem   += "," + this.formData[j]['type'];
          }
        }
      }else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if(this.formData.length === 0){
        this.jiesuanpage = false;
      }
    },
    choosePlay(type,name){
		// console.log(type,name,this.choose)
        if(this.choose[type] === true){
          this.choose[type] = false;
          for(var i = 0;i<this.formData.length;i++){
            if(type === this.formData[i]['type'] ){
                this.formData.splice(i,1)
            }
          }
        }else if(this.choose[type] === false) {
          this.formData.push({'name':name, 'type':type})
          this.choose[type] = true;
        }
        if(this.formData.length === 1){
          this.shopping = true;
        }
        if(this.formData.length >= 1){
          for(var j = 0;j < this.formData.length;j++){
            if(j === 0){
              this.shopchoose = this.formData[j]['name'];
              this.gameitem = this.formData[j]['type'];
            }else {
              this.shopchoose += ","+this.formData[j]['name'];
              this.gameitem += ","+this.formData[j]['type'];
            }
          }
        }else {
          this.shopchoose = this.$t("reservation.no_choose");
          this.gameitem = "";
          this.shopping = false;
        }

    },
    check(){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        time = window.setInterval(() => {
          setTimeout(()=>{
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if(count > 5){
              clearInterval(time);
              count = 0;
            }
          },0)
        }, 300)
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getLotteryPeilv(){
      this.$http({
        method: 'post',
        data:{id:this.$route.query.id},
        url: 'lottery_get_peilv'
      }).then(res=>{
        if(res.code === 200){
          this.lottery_peilv_list = res.data;
          // console.log( this.lottery_peilv_list)
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getLotteryList(){
      this.$http({
        method: 'get',
        data:{key:this.$route.query.key},
        url: 'lottery_get_one_list'
      }).then(res=>{
        if(res.code === 200){
          this.lottery_list = res.data;
          // console.log('lottery_list:')
          // console.log(res.data)
          this.getLotteryPeilv();
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getLotteryInfo(){
      this.$http({
        method: 'get',
        data:{key:this.$route.query.key},
        url: 'lottery_get_info'
      }).then(res=>{
        if(res.code === 200){
          if(parseFloat(this.userInfo.money) < parseFloat(res.data.condition)){
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({path:'/Home'})
            return false;
          }
          this.lottery = res.data;
          this.time = res.data.second * 1000;

          if(this.time/1000 === 59){
            this.$toast(this.$t("reservation.prize_succ")+this.lottery.now_expect);
          }
          this.shanzi_1 = "img/lottery/shaizi/" + res.data?.opencode[0] + ".png";
          this.shanzi_2 = "img/lottery/shaizi/" + res.data?.opencode[1] + ".png";
          this.shanzi_3 = "img/lottery/shaizi/" + res.data?.opencode[2] + ".png";
          this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
          if(this.sum >= 11 && this.sum <=18){
            
            this.size = 'FB';
          }else if(this.sum >= 3 && this.sum <= 10){
            
            this.size = 'TK';
          }
          if(this.sum % 2 === 0){
            
            this.double = 'YT';
          }else {
           
            this.double = 'IG';
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })

    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
        this.getUserInfo();
        this.getLotteryInfo();
        this.getLotteryList();
    }
  },
  destroyed() {
    clearInterval(time);
  }
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base";
// .container{
// 	z-index: 2026 !important;
// }
.nav-bar .right{
  padding-left: 8px;
  padding-right: 8px;
  color: #fff;
  font-size: 28px;
  border-radius: 10px;
  border: 2px solid #fff;
  line-height: 60px;
}
.record{
  padding-left: 20px;
  padding-right: 20px;
  /* background-color: #fff; */
  box-shadow: 0 2px 2px 0 #cacaca;
  z-index: 1;
}
.record .period{
  display: flex;
  align-items: center;
  padding: 20px 0;
}
.record .period .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.record .period .period-number{
  flex: 1;
  margin-left: 20px;
  margin-right: 10px;
  height: 50px;
  line-height: 50px;
  font-size: 35px;
  font-weight: 700;
  color: @fColor;
}
.van-count-down {
  color: #ff253f;
  font-size: 45px;
  margin-top: 10px;
  float: right;
}
.linear-gradient{
  width: 100%;
  height: 2px;
}
.record .recent{
  display: flex;
  align-items: center;
  height: 110px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: @fColor;
}
.kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 35px;
}
.van-icon {
  font-size: 40px;
}
.down {
  transition: all .5s;
}
.up{
  transform: rotate(180deg);
  transition: all .5s;
}
.wrapper{
  position: relative;
  flex: 1;
  overflow: hidden;
}
.options-bar{
  display: flex;
  align-items: center;
  height: calc(100% - 80px);
}
.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-image: url(/public/img/lottery/lottery_bg.png);
  background-size: 100% 100%;
}
.options-bar .game .tips{
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding: 10px 20px;
  gap: 15px;
}
.options-bar .game .tips .tip-btn{
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(230, 195, 161, 0.3);
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.options-bar .game .tips .tip-btn.left-btn{
  flex: 0 0 auto;
}
.options-bar .game .tips .tip-btn.right-btn{
  flex: 0 0 auto;
  margin-left: auto;
}
.options-bar .game .tips .tip-btn:hover{
  background: rgba(0, 0, 0, 0.8);
  border-color: rgba(230, 195, 161, 0.5);
}
.options-bar .game .tips .tip-btn .tip-icon{
  font-size: 32px;
  color: #e6c3a1;
  margin-right: 8px;
}
.options-bar .game .tips .tip-btn .tip-text{
  font-size: 26px;
  color: #fff;
  white-space: nowrap;
}
.options-bar .game .tips .tip-btn .tip-text .van-count-down{
  display: inline;
  color: #ff253f;
  font-size: 26px;
  margin: 0;
  float: none;
}
.linear-gradient{
  width: 100%;
  height: 2px;
}
.platform-title{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0 20px;
  gap: 15px;
}
.platform-title .diamond-left,
.platform-title .diamond-right{
  font-size: 16px;
  color: #e6c3a1;
}
.platform-title .title-text{
  font-size: 32px;
  font-weight: 600;
  color: #e6c3a1;
  letter-spacing: 2px;
}
.sumValueTwoSides{
  display: flex;
  padding: 10px 8vw 30px;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}
.rectangle{
  overflow: visible;
}
.rectangle.large{
  margin: 0;
  width: calc(50% - 10px);
  flex: 0 0 calc(50% - 10px);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.95);
  border: 3px solid rgba(200, 200, 200, 0.5);
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.rectangle.large:hover{
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}
.rectangle.large.active{
  border: 3px solid #ff4d7d;
  background: rgba(255, 245, 248, 0.98);
  box-shadow: 0 6px 20px rgba(255, 77, 125, 0.3);
}
.rectangle.large img{
  width: 18vw;
  max-width: 100px;
}
.rectangle .wrapper{
  position: relative;
  padding: 0 10px;
  background: transparent;
}
.rectangle .wrapper .content{
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-bottom: 30px;
}
.rectangle .wrapper .check-icon{
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #d0d0d0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.rectangle.large.active .wrapper .check-icon{
  background: #ff4d7d;
}
.rectangle .wrapper .check-icon .van-icon{
  font-size: 20px;
  color: #fff;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}
.rectangle.large.active .wrapper .check-icon .van-icon{
  opacity: 1;
}
.rectangle.large .wrapper{
  padding-bottom: 100%;
}
.rectangle .wrapper .content .name-text.large{
  font-size: 4vw;
  margin-bottom: 0;
}
.rectangle .wrapper .content .name-text{
  color: #333;
  font-weight: bolder;
  margin: 0;
}
.rectangle .wrapper .content .odd-text.large{
  font-size: 28px;
  margin-top: 8px;
}
.rectangle .wrapper .content .odd-text{
  text-align: center;
  color: #333;
  font-weight: 600;
  margin: 0;
}
.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100px;
  z-index: 2;
}
.bottom-bar .bar .left, .bottom-bar .bar{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background-color: @pageBg;
  box-shadow: 0 0 5px 0 #cacaca;
  z-index: 2;
}
.bottom-bar .bar .left, .bottom-bar .bar{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar .left .item{
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  gap: 12px;
  font-size: 20px;
}
.bottom-bar .bar .left .item .text{
  font-size: 22px;
  color: #7d7c7c;
  white-space: nowrap;
}
.jixuanico{
  font-size: 45px;
}
.bottom-bar .bar .left .line{
  width: 2px;
  height: 50px;
  background: #dadada;
}
.bottom-bar .bar .mid{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.bottom-bar .bar .mid .text{
  font-size: 30px;
  font-weight: 500;
  color: @fColor;
}
.bottom-bar .bar .mid .text.num{
  margin: 0 5px;
  color: #ff253f;
}
.bottom-bar .bar .right{
  padding: 0 30px;
  margin: 0 30px;
  color: #fff;
  background: linear-gradient(135deg, #ff4d6d, #e63950);
  font-size: 30px;
  font-weight: 500;
  height: 70px;
  line-height: 70px;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(255, 37, 63, 0.3);
}
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: @fColor;
  font-size: 35px;
}
::v-deep   .van-popup {
  position: absolute;
}
::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}
::v-deep  .van-popup--top {
  top: -1px;
}
.wrapper .item{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}
.wrapper .item2{
  background: @theme1;
}
.wrapper .item .left{
  width: 40%;
  font-size: 30px;
  text-align: center;
  font-weight: 500;
  color: @fColor;
}
.font-weight{
  font-weight: 700!important;
}
.wrapper .item .right{
  flex: 1;
  display: flex;
  font-size: 30px;
  justify-content: center;
  overflow: hidden;
  color: @fColor;
}
.wrapper .item .kuaisan-ball .left{
  justify-content: flex-start;
}
.wrapper .item .kuaisan-ball{
  margin-left: 20px;
  flex: 1;
  display: flex;
  align-items: center;
}
.wrapper .item .kuaisan-ball .res-img{
  width: 50px;
  height: 50px;
  margin-right: 20px;
}
.wrapper .item .kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: @fColor;
}
.wrapper .item .kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 3vw;
}
.play-type-tip{
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 650px;
  height: 700px;
  max-height: 50%;
  z-index: 10;
  border-radius: 30px;
  overflow: hidden;
  background-color: #fff;
  color: @fColor;
}
.play-type-tip .title{
  line-height: 90px;
  background: linear-gradient(
      90deg,#7e5678,#e6c3a1);
  text-align: center;
  color: #fff;
  font-size: 35px;
  font-weight: 500;
}
.mask{
  background-color: rgb(0 0 0 / 0%);
  animation-duration: 0.35s;
}
.play-type-tip .wrapper{
  height: calc(100% - 10px);
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.play-type-tip .wrapper .item{
  padding: 40px 50px;
  display: flex;
  align-items: flex-start;
}
.play-type-tip .wrapper .item .van-icon{
  color: #e6c3a1;
  font-size: 60px;
}
.play-type-tip .wrapper .item .content .content-title{
  margin-top: 22px;
  font-size: 35px;
  font-weight: 500;
  color: @fColor;
  line-height: 0px;
}
.play-type-tip .wrapper .item .content .content-detail{
  margin-top: 5px;
  font-size: 22px;
  color: @fColor;
  line-height: 30px;
}
.play-type-tip .wrapper .item .content{
  flex: 1;
  margin-left: 30px;
}
.bottom-bar .wrapper{
  position: absolute;
  top: 1px;
  left: 0;
  right: 0;
  padding: 20px 20px 10px 20px;
  height: 230px;
  // background: linear-gradient(135deg, #2a2a3e, #1f1f2e);
  background: linear-gradient(30deg, #1c1c1c, #201b1f);
  z-index: 1;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  border-radius: 20px 20px 0 0;
  transition: transform .3s cubic-bezier(.21,1.02,.55,1.01);
}
.bottom-bar .wrapper.active{
  transform: translateY(-100%);
}
.bottom-bar .wrapper .item{
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 65px;
  padding: 0 10px;
  margin-bottom: 5px;
}
.bottom-bar .wrapper .item .icon-box{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  border-radius: 50%;
  background: rgba(230, 195, 161, 0.15);
  margin-right: 15px;
  flex-shrink: 0;
}
.bottom-bar .wrapper .item .item-icon{
  font-size: 24px;
  color: #e6c3a1;
}
.bottom-bar .wrapper .item .label{
  font-size: 28px;
  line-height: 30px;
  color: #b8b8c8;
  white-space: nowrap;
  margin-right: 10px;
}
.bottom-bar .wrapper .item .bet-number{
  flex: 1;
  margin: 0 10px;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  color: #fff;
  font-size: 28px;
  font-weight: 400;
  height: 40px;
  line-height: 40px;
}
.bottom-bar .wrapper .item .amount-wrapper{
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .wrapper .item .summary{
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
.bottom-bar .wrapper .item .summary span{
  font-size: 26px;
  color: #b8b8c8;
  margin-right: 5px;
}
.bottom-bar .wrapper .item .summary .number.highlight{
  color: #ff253f;
  font-weight: 600;
  font-size: 28px;
}
.bottom-bar .wrapper .item .summary .divider{
  margin: 0 10px;
  color: #666;
}
.van-cell {
  font-size: 28px;
  line-height: 50px;
  background: linear-gradient(30deg, #1c1c1c, #201b1f);
  border: 1px solid rgba(230, 195, 161, 0.2);
  border-radius: 8px;
}
.bottom-bar .wrapper .item .part{
  margin-right: 20px;
}
.bottom-bar .wrapper .item .part span{
  font-size: 30px;
  vertical-align: center;
  color: @fColor;
}
.bottom-bar .wrapper .item .part .number{
  margin: 0 5px;
  color: #ff253f;
  font-weight: 500;
}
::v-deep .van-field__control {
  color: #fff;
  font-size: 26px;
}
::v-deep .van-cell::after {
  border: none;
}
.confirm-order-modal{
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 20px 30px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 610px;
  height: 680px;
  max-height: 50%;
  z-index: 10;
  background-color: @pageBg;
  border-radius: 30px;
}
.confirm-order-modal .head{
  position: relative;
  height: 80px;
}
.confirm-order-modal .head .text{
  padding: 0 20px;
  height: 30px;
  line-height: 10px;
  text-align: center;
  font-size: 35px;
  font-weight: 500;
  color: #7e5678;
}
::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: 2px;
}
.van-popup--center {
  border-radius: 30px;
}
.confirm-order-modal .list{
  flex: 1;
  padding: 0 10px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.confirm-order-modal .list .lise-item{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0;
}
.confirm-order-modal .list .lise-item .main{
  flex: 1;
  overflow: hidden;
}
.confirm-order-modal .list .lise-item .main .bet-name{
  color: #ff253f;
  font-size: 35px;
  font-weight: 500;
  line-height: 0px;
  word-wrap: break-word;
  word-break: break-all;
}
.confirm-order-modal .list .lise-item .main  .detail-text{
  line-height: 0px;
  font-size: 25px;
  color: #979799;
}
.confirm-order-modal .list .lise-item{
  color: #ff253f;
}
.confirm-order-modal .sub-bar{
  display: flex;
  align-items: center;
  margin-top: 30px;
  justify-content: space-around;
}
.confirm-order-modal .sub-bar .item{
  min-width: 40%;
  height: 80px;
  text-align: center;
  box-sizing: border-box;
  border-radius: 50px;
  font-size: 35px;
  font-weight: 500;
}
.confirm-order-modal .sub-bar .item.cancel-btn{
  border: 2px solid #666;
  color: #fff;
  background-color: #666;
}
.confirm-order-modal .sub-bar .item.sub-btn{
  background: linear-gradient(
      270deg,#e6c3a1,#7e5678);
  color: #fff;
  border: 0;
}
.next-number span{
  font-size: 35px;
  font-weight: 700;
  color: @fColor;
  float: right;
}

::v-deep .my-drawer {
  background-color: #f6f6f5;
  
  .el-drawer__body {
    background-color: #f6f6f5;
    color: #333;
  }
}
.menu-item{
	padding: 2vh 0 2vh 5vw;
	font-weight: 700;
	font-style: normal;
	font-family: Lato, sans-serif;
	font-size: .8em;
	border-top: 1px solid #ececec;
}
</style>
